import Vue from "vue";
import { JUMP_ROOM_CHANNEL_EVENT } from "./constants/global";

const EventBus = new Vue();

/**
 * @description 使用DynamicDialog组件
 * @param {string} name DynamicDialog组件里面 imports文件里面对应组件的名字
 * @param  {any[]} args 初始化动态弹窗时候的参数
 */
EventBus.$dynamic = function (name, ...args) {
  EventBus.$emit("show-dynamic-dialog", name, ...args);
};

/**
 * @description 跳转房间和频道的函数,统一触发到MainLayout入口函数进行处理以及上报
 * @param  {object} data 跳转的控制参数
 * @param  {string} pos 跳转需要上报的信息
 * @param  {string} tag 跳转的标签信息
 */
EventBus.$jump = function (data, pos, tag) {
  // 清空原来的Task，并开启一个新的
  window.timing_collector.update('start');

  EventBus.$emit(JUMP_ROOM_CHANNEL_EVENT, data, pos, tag);
};

export default EventBus;
